import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserRoleTypes } from '@enums';

import { AuthService } from '@services/data-integration/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SupplierGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> | boolean {
    const isAuthenticated = this.authService.isAuthenticated();

    if (isAuthenticated) {
      return this.authService.getCurrentUser().pipe(
        map(user => {
          if (user?.role.type === UserRoleTypes.SUPPLIER) {
            return true;
          }

          this.router.navigate(['/subcontractor']);
          return false;
        }),
      );
    }

    return false;
  }
}
